import { AlertTriangle, SearchX } from "lucide-react";
import { KineticTextLoader } from "./KineticTextLoader";

interface StateBlockProps {
  type: "loading" | "error" | "empty";
  title: string;
  message: string;
}

export function StateBlock({ type, title, message }: StateBlockProps) {
  const Icon = type === "error" ? AlertTriangle : SearchX;

  return (
    <div className={`state-block state-${type}`}>
      {type === "loading" ? <KineticTextLoader className="state-block__loader kinetic-text-loader--large" /> : <Icon size={22} aria-hidden="true" />}
      <div>
        <strong>{title}</strong>
        <span>{message}</span>
      </div>
    </div>
  );
}
